import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { authService, userService } from "../../services/api";
import { setCredentials } from "../../store/slices/authSlice";
import Header from "./Header";
import ImpersonationBanner from "./ImpersonationBanner";
import MaintenanceMode from "../common/MaintenanceMode";
import maintenanceMode from "../../utils/maintenanceMode";

const PrivateLayout = ({ children, hideHeader = false }) => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    const initializeAuth = async () => {
      const storedTokens = JSON.parse(localStorage.getItem("tokens"));
      const storedUser = JSON.parse(localStorage.getItem("user"));

      // If we have stored data but no redux state, restore it
      if (storedTokens && storedUser && !auth.user) {
        dispatch(setCredentials({ tokens: storedTokens, user: storedUser }));
        // Fall through to try fetching fresh profile to hydrate permissions
      }

      // If we have tokens but no user data, try to refresh the session
      if (storedTokens?.refresh && !auth.user) {
        const response = await authService.refreshTokens();
        if (!response.success) {
          authService.logout();
        } else {
          // Access token refreshed, proceed to fetching profile below
        }
      } else if (!storedTokens?.refresh) {
        authService.logout();
      }
    };

    initializeAuth();
  }, [dispatch]);

  // Maintenance Mode Check - This overrides everything else
  if (maintenanceMode.isEnabled()) {
    return <MaintenanceMode />;
  } 

  return (
    // Flex column so a page can fill the remaining height instead of a second
    // min-h-screen — a doubled min-h-screen (layout + page) is taller than the
    // viewport by the header's height and leaves a permanent phantom page
    // scrollbar (A1).
    <div className="min-h-screen bg-white flex flex-col">
      {/* "View as" preview banner (TP-View-As): on EVERY private page, even
          when the header is hidden — renders null unless a preview is
          active. */}
      <ImpersonationBanner />
      {!hideHeader && <Header />}
      {/* Content region: a full-width flex child that grows to fill the
          remaining height AND re-establishes a block formatting context for the
          page. Rendering {children} directly as flex items made any page whose
          root uses `mx-auto` (Lawyers, profiles, News, Search, …) shrink-wrap
          and center into a narrow strip — auto cross-axis margins defeat
          flex `stretch`. Wrapping restores normal block width while a page can
          still fill the height via `min-h-full` (A5). */}
      <div className="flex-1 min-w-0">{children}</div>
    </div>
  );
};

export default PrivateLayout;
